module.exports = {
  init: function () {
    var $ = window.$;

    /**
     *  Navigation with selector for tabs
     */
    if ($('.js-tab-select-navigation').length > 0) {
      $('.js-tab-select-navigation').on('change', function (e) {
        var target = $(this).val(),
          tabContent = $(this).data('content');
        $(tabContent).find('.tab-pane').removeClass('active in');
        $(target).addClass('active in');
      });
    }

    /**
     *  Navigation lateral with selector
     */
    if ($('.js-link-select-navigation').length > 0) {
      $('.js-link-select-navigation select').on('change', function (e) {
        if ($(this).val() !== '') {
          window.location.href = $(this).val();
        }
      });
    }

    /**
     *  Booking add note
     */
    if ($('.js-add-booking-note-trigger').length > 0) {
      $('.js-add-booking-note-trigger').on('click', function (e) {
        $(this).hide();
        $('.js-add-booking-note').show();
      });
    }
  },
  /**
   *  Add-on for react-widget DropDownList
   */
  scrollToAvailableTime: function (id, entryCount) {
    const selector = '.rw-list';
    const scrollHeight = 30;
    const paddingTop = 7;
    let targetElement;

    setTimeout(() => {
      targetElement = document.querySelector(`#${id} ${selector}`, 0);
      if (targetElement && entryCount) {
        const offsetTop = entryCount * scrollHeight + paddingTop;
        targetElement.scrollTop = offsetTop;
      }
    }, 0);
  },
  setAvailabilityChartWidth: function () {
    var summaryWidth = $('#availability-card-summary').width();
    $('.availability-card-main').css({
      width: `calc(100% - ${summaryWidth}px)`,
    });
  },
};
